import React, { useEffect , useState} from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Article from "../components/articles/article";


import Articalservice from "../service/Articalservice";
import "./styles/articles.css";

const Articles = () => {
	const [data, setData] = useState([]);
	
	useEffect(() => {
	  getData();
	}, []);
  
	const getData = async () => {
	  try {
		const response = await Articalservice.getAllInfo();
		const newData = response.docs.map((doc) => doc.data()); // Extract data from each document
		setData(newData);
	  } catch (error) {
		console.error("Error fetching data:", error);
	  }
	};
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	

	return (
		<React.Fragment>
		

			<div className="page-content">
				<NavBar active="articles" />
				<div className="content-wrapper">
					<div className="articles-logo-container">
						<div className="articles-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="articles-main-container">
						<div className="title articles-title">
							{data.title}
						</div>

						<div className="subtitle articles-subtitle">
							{data.description}
						</div>

						<div className="articles-container">
							<div className="articles-wrapper">
								<Article></Article>
							</div>
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Articles;
